<div class="shimmer" />

<style>
  .shimmer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-x: hidden;
    pointer-events: none;
  }

  .shimmer::after {
    content: "";
    position: absolute;
    top: 0;
    right: -100%;
    bottom: 0;
    left: -100%;
    background-image: linear-gradient(
      to right,
      rgb(255 255 255 / 0) 33.3%,
      rgb(255 255 255 / 0.8),
      rgb(255 255 255 / 0) 66.6%
    );
    animation: shimmer 1.2s infinite cubic-bezier(0.42, 0, 0.5, 1);
  }

  @keyframes shimmer {
    from {
      transform: translateX(-33.3%);
    }
    to {
      transform: translateX(33.3%);
    }
  }
</style>
